export default __webpack_public_path__ + "static/media/ic_latvia.959921bc.svg";